import { colors, breakpoints } from 'style'
import styled from 'styled-components'

export const FooterContainer = styled.footer`
  background: ${colors.dark8};
  color: ${colors.white} !important;
  padding: 58px 114px 65px;
  .footer-col {
    display: flex;
    flex-direction: column;
    .social-wrapper {
      display: flex;
      a {
        font-size: 16px;
        margin-right: 27px;
      }
    }
    h4 {
      color: ${colors.white};
      font-weight: 500;
      margin-bottom: 20px;
      font-size: 16px;
    }
    a {
      color: ${colors.white};
      font-size: 14px;
      font-weight: 400;
    }
    .lang-selector {
      .dropdown-toggle {
        border: unset;
        padding: 0;
        color: white;
        font-size: 14px;
      }
      .dropdown-menu {
        background-color: #333333;
        max-width: 120px;
        a {
          color: ${colors.gray};
          font-size: 14px;
          padding: 5px 11px;
        }
      }
    }
  }
  .footer-bottom {
    display: flex;
    margin-top: 50px;
    a {
      margin-right: 100px;
      color: ${colors.white};
      font-size: 14px;
      font-weight: 400;
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    padding: 72px 18px 112px;
    .footer-col {
      margin-bottom: 50px;
    }
    .footer-bottom {
      margin-top: 0;
      display: flex;
      flex-direction: column;
    }
  }
`
